export default __webpack_public_path__ + "static/media/500-internal-server-error.4e6d49f9.svg";